import { useSearchParams } from 'react-router-dom';

export function useTimezone() {
  const [searchParams] = useSearchParams();
  return searchParams.get('timezone') || Intl.DateTimeFormat().resolvedOptions().timeZone;
}
